import Race, { type RaceFieldProps } from '../../../components/fields/RaceField';
import SelectField from './SelectField';

const RaceField = (props: RaceFieldProps) => <Race SelectComp={SelectField} {...props} />;

export default RaceField;
